import React from "react";

export const Maximize = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="true"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 18 18"
    >
      <path
        fillRule="evenodd"
        d="M3.75 1.5H6c.45 0 .75.3.75.75S6.45 3 6 3H3.75C3.3 3 3 3.3 3 3.75V6c0 .45-.3.75-.75.75S1.5 6.45 1.5 6V3.75c0-1.275.975-2.25 2.25-2.25zM6 16.5c.45 0 .75-.3.75-.75S6.45 15 6 15H3.75c-.45 0-.75-.3-.75-.75V12c0-.45-.3-.75-.75-.75s-.75.3-.75.75v2.25c0 1.275.975 2.25 2.25 2.25H6zm9.75-5.25c-.45 0-.75.3-.75.75v2.25c0 .45-.3.75-.75.75H12c-.45 0-.75.3-.75.75s.3.75.75.75h2.25c1.275 0 2.25-.975 2.25-2.25V12c0-.45-.3-.75-.75-.75zM12 1.5h2.25c1.275 0 2.25.975 2.25 2.25V6c0 .45-.3.75-.75.75S15 6.45 15 6V3.75c0-.45-.3-.75-.75-.75H12c-.45 0-.75-.3-.75-.75s.3-.75.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  );
};
